import { render, staticRenderFns } from "./ClinicNotFound.vue?vue&type=template&id=8b1cdd54"
import script from "./ClinicNotFound.vue?vue&type=script&lang=js"
export * from "./ClinicNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports